import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import redirect from 'js/lib/coursera.redirect';

// TODO(jnam) remove this along with other old CDP files from the code-base
class PhoenixEnrollModal extends React.Component {
  static contextTypes = {
    course: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof PhoenixEnrollModal.contextTypes>;

  componentDidMount() {
    const { course } = this.context;
    redirect.setLocation(`/learn/${course.get('slug')}?action=enroll`);
  }

  render() {
    return false;
  }
}

export default PhoenixEnrollModal;
